module.exports = __webpack_public_path__ + "img/info-01.8c6b6d1a.jpg";